import(/* webpackMode: "eager" */ "/app/app/pools/page.tsx");
